import Icon from 'components/icon';
import ProductIdentifierModal from 'components/modal/product-identifier';
import { useMenu } from 'context/MenuContext';
import Application from 'models/Application';
import Status from 'models/Status';
import { useState } from 'react';
import MenuItem from './item';
import styles from './styles.module.scss';

function Product(props : Application) : JSX.Element {
  const { openedMenu, updateOpenedMenu } = useMenu();

  const [isModalOpen, setModalStatus] = useState(false);

  const isMigrated = () : boolean => props.status === undefined;
  const isOpened = props.noun == openedMenu && isMigrated();

  const onClick = () : void => {
    if(isMigrated()) {
      updateOpenedMenu(props.noun);
      return;
    }

    if(props.status == Status.without_access) {
      setModalStatus(true);
      return;
    }

    window.location.href = props.callbackURL;
    return;
  };

  const getIcon = () : JSX.Element => {
    if (!isMigrated())
      return <Icon className={styles['biobar-redirect-icon']} iconName='launch'/>;

    if(!isOpened)
      return <Icon id={`biobar-product-${props.applicationName}`} iconName='expand_more'/>;

    return <></>;
  };

  const productName = () : JSX.Element => {
    let img = <></>;
    try {
      img = <img src={require(`../../../assets/products-logo/${props.applicationName}.png`)} alt="" />;
    } catch { console.log('[Biobar]: Image not found'); }

    return (
      <div
        className={`${styles['biobar-product']}
        ${isOpened && styles['biobar-current-product']}`}
        onClick={onClick}>
        <div className={styles['biobar-product-name']}>
          {img}
          <p>{props.noun}</p>
        </div>
        {getIcon()}
      </div>
    );
  };

  const getChilds = () : JSX.Element => {
    if(!isOpened) return <></>;
    if(props.menu === undefined) return <></>;

    return (
      <div className={styles['biobar-menu']}>
        { props.menu.map((menuItem, i) => <MenuItem
          productNoun={props.noun}
          menu={menuItem} key={i}/>)
        }
      </div>
    );
  };

  return (
    <>
      <div className={styles['biobar-product-div']}>
        {productName()}
        {getChilds()}
      </div>
      {isModalOpen &&
        <ProductIdentifierModal
          applicationName={props.applicationName}
          applicationNoun={props.noun}
          callbackUrl={props.callbackURL}
          closeModal={() : void => { setModalStatus(false); }}
        />
      }
    </>
  );
}

export default Product;